export const environment = {
  production: true,
  vueApp: 'https://testing.insurancetoolkits.com',
  djangoApi: 'https://testing.insurancetoolkits:8080',
  api: 'https://leads.uw-staging.insurancetoolkits.com',
  geoApi: 'https://geo.uw-staging.insurancetoolkits.com',
};
